import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import * as ReactBootstrap from 'react-bootstrap';
import { useAppContext } from '../../context/AppContext.js';
import Title from '../../components/Title.js';
import ActionsBar from '../../components/ActionsBar.js';
import Button from '../../components/Button.js';
import IconBudgetCapital from '../../components/icons/IconBudgetCapital.js';
import IconStatus from '../../components/icons/IconStatus.js';
import IconAmount from '../../components/icons/IconAmount.js';
import IconComment from '../../components/icons/IconComment.js';
import BudgetCapitalTopPart1 from './BudgetCapitalTopPart1.js';
import BudgetCapitalTopPart2 from './BudgetCapitalTopPart2.js';
import BudgetCapitalTopPart3 from './BudgetCapitalTopPart3.js';
import BudgetCapitalTopPart4 from './BudgetCapitalTopPart4.js';
import BudgetCapitalTopPart5 from './BudgetCapitalTopPart5.js';
import BudgetCapitalTopPart6 from './BudgetCapitalTopPart6.js';
import BudgetCapitalTopAction1 from './BudgetCapitalTopAction1.js';
import BudgetCapitalTopAction2 from './BudgetCapitalTopAction2.js';
import BudgetCapitalTopAction3 from './BudgetCapitalTopAction3.js';
import ApiService from '../../services/ApiService.js';
import SecurityService from '../../services/SecurityService.js';
import { getWords } from '../../utils/get-words.js';
import { isValid } from '../../utils/is-valid.js';
import { protect } from '../../utils/protect.js';

const BudgetCapitalTop = ReactRouterDOM.withRouter(function ({ budgetCapital, data, updateData, validated }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const [action, setAction] = React.useState(null);
  const [actionData, setActionData] = React.useState(null);
  const [actionPath, setActionPath] = React.useState(null);
  const [actionBody, setActionBody] = React.useState(null);
  const [actionValidated, setActionValidated] = React.useState(null);
  const bodyRefAction0 = React.useRef(null);
  const bodyRefAction1 = React.useRef(null);
  const bodyRefAction2 = React.useRef(null);

  const handleAction0 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setAction({ index: 0 });
    const path = {};
    path.budgetCapitalId = budgetCapital.budgetCapitalId;
    setActionPath(path);
  }
  const submitAction0 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefAction0.current)) {
      try {
        await ApiService.putBudgetCapitalSetInRevision(actionPath.budgetCapitalId, actionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setAction(null);
      setActionPath(null);
      setActionValidated(null);
      window.location.reload();
    }
    else {
      setActionValidated(true);
    }
  }
  const handleAction1 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setAction({ index: 1 });
    const path = {};
    path.budgetCapitalId = budgetCapital.budgetCapitalId;
    setActionPath(path);
  }
  const submitAction1 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefAction1.current)) {
      try {
        await ApiService.putBudgetCapitalSetConfirmed(actionPath.budgetCapitalId, actionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setAction(null);
      setActionPath(null);
      setActionValidated(null);
      window.location.reload();
    }
    else {
      setActionValidated(true);
    }
  }
  const handleAction2 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setAction({ index: 2 });
    const path = {};
    path.budgetCapitalId = budgetCapital.budgetCapitalId;
    setActionPath(path);
  }
  const submitAction2 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefAction2.current)) {
      try {
        await ApiService.putBudgetCapitalSetSent(actionPath.budgetCapitalId, actionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setAction(null);
      setActionPath(null);
      setActionValidated(null);
      window.location.reload();
    }
    else {
      setActionValidated(true);
    }
  }
  const updateActionData = function (field, value) {
    setActionData({ ...actionData, [field]: value });
  }
  const updateActionPath = function (field, value) {
    setActionPath({ ...actionPath, [field]: value });
  }
  const updateActionBody = function (field, value) {
    setActionBody({ ...actionBody, [field]: value });
  }
  const cancelAction = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setAction(null);
    setActionData(null);
    setActionValidated(null);
  }
  
  return (
    <div>
      <div>
        <div className="pb-1 d-flex align-items-center border-bottom">
          <Title level={1} icon={IconBudgetCapital} color="blue" label={words.budgetCapital} />
          <div className="flex-grow-1" />
          <ActionsBar
            actions={[
              { icon: IconStatus, label: words.moveToRevision, color: 'red', onClick: handleAction0, hidden: !(protect(function ([status]) { return status === 'confirmed' }, [ budgetCapital.status ]) && (SecurityService.hasRole('administrator'))) },
              { icon: IconStatus, label: words.confirmAmounts, color: 'gold', onClick: handleAction1, hidden: !(protect(function ([status]) { return status === 'inRevision' }, [ budgetCapital.status ]) && (SecurityService.hasRole('officer'))) },
              { icon: IconStatus, label: words.sendAmounts, color: 'green', onClick: handleAction2, hidden: !(protect(function ([status]) { return status === 'confirmed' }, [ budgetCapital.status ]) && (SecurityService.hasRole('administrator'))) },
            ]}
          />
        </div>
        <div>
          {budgetCapital ?
            <div className="pb-3">
              <BudgetCapitalTopPart1 budgetCapital={budgetCapital} />
            </div> :
            null
          }
          {budgetCapital ?
            <div className="pb-3">
              <BudgetCapitalTopPart2 budgetCapital={budgetCapital} />
            </div> :
            null
          }
          {budgetCapital ?
            <div className="pb-3">
              <BudgetCapitalTopPart3 budgetCapital={budgetCapital} data={data} updateData={updateData} validated={validated} />
            </div> :
            null
          }
          {budgetCapital ?
            <div className="pb-3">
              <BudgetCapitalTopPart4 budgetCapital={budgetCapital} />
            </div> :
            null
          }
          {budgetCapital ?
            <div className="pb-3">
              <BudgetCapitalTopPart5 budgetCapital={budgetCapital} data={data} updateData={updateData} validated={validated} />
            </div> :
            null
          }
          {budgetCapital ?
            <div className="pb-3">
              <BudgetCapitalTopPart6 budgetCapital={budgetCapital} />
            </div> :
            null
          }
        </div>
      </div>
      {action && action.index === 0 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="red" label={words.moveToRevision} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefAction0} className="p-0">
            <div className="p-2">
              <BudgetCapitalTopAction1 budgetCapital={budgetCapital} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="red" onClick={submitAction0} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
      {action && action.index === 1 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="gold" label={words.confirmAmounts} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefAction1} className="p-0">
            <div className="p-2">
              <BudgetCapitalTopAction2 budgetCapital={budgetCapital} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="gold" onClick={submitAction1} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
      {action && action.index === 2 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="green" label={words.sendAmounts} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefAction2} className="p-0">
            <div className="p-2">
              <BudgetCapitalTopAction3 budgetCapital={budgetCapital} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="green" onClick={submitAction2} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
    </div>
  );
})

export default BudgetCapitalTop;
